import { WorkingCenterModelType } from '@teinor/erp/types/company/workingCenter'
import { LittleModalCreateEdit } from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { PdfQuoteOrderTemplatePayload } from '../../../../../../../../../../utils/reducers/company/pdfQuoteOrderTemplates'
import { connect, ConnectedProps } from 'react-redux'
import { AllReduxPayloads } from '../../../../../../../../../../utils/reducers'
import withLoading from '../../../../../../../../../../utils/hoc/withLoading'
import { addDictionaryExtraLine, dictionaryComplexFromJsonArr } from '../../../../../../../../../../utils/globals/dictionary'
import { useMemo } from 'react'

type ModalConfigWCTemplatesPDFProps = ModalEditComponentProps & ReduxModalConfigWCTemplatesPDF & { }

const ModalConfigWCTemplatesPDF: React.FC<ModalConfigWCTemplatesPDFProps> = ({ basicData, pdfTemplates, setOpened, onSubmit }: ModalConfigWCTemplatesPDFProps) => {
    const { t } = useTwinTranslation()
    const dictPdfQuoteOrderTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.quoteOrder || [])), [pdfTemplates?.quoteOrder])
    const dictPdfBuyOrderTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.buyOrder || [])), [pdfTemplates?.buyOrder])
    const dictPdfBuyDeliveryNoteTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.buyDeliveryNote || [])), [pdfTemplates?.buyDeliveryNote])
    const dictPdfBuyInvoiceTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.buyInvoice || [])), [pdfTemplates?.buyInvoice])
    const dictPdfSellOrderTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.sellOrder || [])), [pdfTemplates?.sellOrder])
    const dictPdfSellDeliveryNoteTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.sellDeliveryNote || [])), [pdfTemplates?.sellDeliveryNote])
    const dictPdfSellInvoiceTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.sellInvoice || [])), [pdfTemplates?.sellInvoice])
    const dictPdfStockMaterialTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.customerMaterialStockOrder || [])), [pdfTemplates?.customerMaterialStockOrder])
    const dictPdfSellInvoiceRefundTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.sellRefundInvoice || [])), [pdfTemplates?.sellRefundInvoice])
    const dictPdfSellDeliveryNoteRefundTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.sellRefundDeliveryNote || [])), [pdfTemplates?.sellRefundDeliveryNote])
    const dictPdfSellTicketTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.ticket || [])), [pdfTemplates?.ticket])
    const dictPdfSellTicketPDFTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.ticketPDF || [])), [pdfTemplates?.ticketPDF])
    const dictPdfSellTicketRefundTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.ticketRefund || [])), [pdfTemplates?.ticketRefund])
    const dictPdfSellTicketRefundPDFTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.ticketRefundPDF || [])), [pdfTemplates?.ticketRefundPDF])
    const dictPdfVoucherTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.voucher || [])), [pdfTemplates?.voucher])
    const dictPdfVoucherPDFTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.voucherPDF || [])), [pdfTemplates?.voucherPDF])
    const dictPdfGiftTicketTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.giftTicket || [])), [pdfTemplates?.giftTicket])
    const dictPdfManufacturingTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.manufacturingPDF || [])), [pdfTemplates?.manufacturingPDF])
    const dictPdfAdjustmentDeliveryNoteTemplates = useMemo(() => addDictionaryExtraLine(dictionaryComplexFromJsonArr(pdfTemplates?.adjustmentDeliveryNote || [])), [pdfTemplates?.adjustmentDeliveryNote])
    const fields: FormRender<WorkingCenterModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: basicData?.id
                },
                {
                    name: 'PdfQuoteOrderTemplateId',
                    label: t('pdfQuoteOrderTemplate', 'Plantilla PDF de presupuestos'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfQuoteOrderTemplates,
                    value: basicData?.PdfQuoteOrderTemplateId,
                },
                {
                    name: 'PdfBuyOrderTemplateId',
                    label: t('pdfBuyOrderTemplate', 'Plantilla PDF pedido de compras'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfBuyOrderTemplates,
                    value: basicData?.PdfBuyOrderTemplateId,
                },
                {
                    name: 'PdfBuyDeliveryNoteTemplateId',
                    label: t('pdfBuyDeliveryNoteTemplate', 'Plantilla PDF albarán de compras'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfBuyDeliveryNoteTemplates,
                    value: basicData?.PdfBuyDeliveryNoteTemplateId,
                },
                {
                    name: 'PdfBuyInvoiceTemplateId',
                    label: t('pdfBuyInvoiceTemplate', 'Plantilla PDF factura de compras'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfBuyInvoiceTemplates,
                    value: basicData?.PdfBuyInvoiceTemplateId,
                },
                {
                    name: 'PdfSellOrderTemplateId',
                    label: t('pdfSellOrderTemplate', 'Plantilla PDF pedido de ventas'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfSellOrderTemplates,
                    value: basicData?.PdfSellOrderTemplateId,
                },
                {
                    name: 'PdfSellDeliveryNoteTemplateId',
                    label: t('pdfSellDeliveryNoteTemplate', 'Plantilla PDF albarán de ventas'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfSellDeliveryNoteTemplates,
                    value: basicData?.PdfSellDeliveryNoteTemplateId,
                },
                {
                    name: 'PdfSellInvoiceTemplateId',
                    label: t('pdfSellInvoiceTemplate', 'Plantilla PDF factura de ventas'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfSellInvoiceTemplates,
                    value: basicData?.PdfSellInvoiceTemplateId,
                },
                {
                    name: 'PdfCustomerMaterialStockOrderTemplateId',
                    label: t('pdfMaterialStockTemplate', 'Plantilla PDF depósito de materiales'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfStockMaterialTemplates,
                    value: basicData?.PdfCustomerMaterialStockOrderTemplateId,
                },
                {
                    name: 'PdfSellDeliveryNoteRefundTemplateId',
                    label: t('pdfSellDeliveryNoteRefundTemplate', 'Plantilla PDF devolución albarán de ventas'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfSellDeliveryNoteRefundTemplates,
                    value: basicData?.PdfSellDeliveryNoteRefundTemplateId,
                },
                {
                    name: 'PdfSellInvoiceRefundTemplateId',
                    label: t('pdfSellInvoiceRefundTemplate', 'Plantilla PDF devolución factura de ventas'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfSellInvoiceRefundTemplates,
                    value: basicData?.PdfSellInvoiceRefundTemplateId,
                },
                {
                    name: 'PdfSellTicketTemplateId',
                    label: t('sellTicketTemplate', 'Plantilla ticket de venta'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfSellTicketTemplates,
                    value: basicData?.PdfSellTicketTemplateId,
                },
                {
                    name: 'PdfSellTicketPDFTemplateId',
                    label: t('pdfSellTicketPDFTemplate', 'Plantilla PDF ticket de ventas'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfSellTicketPDFTemplates,
                    value: basicData?.PdfSellTicketPDFTemplateId,
                },
                {
                    name: 'PdfSellTicketRefundTemplateId',
                    label: t('sellTicketRefundTemplate', 'Plantilla devolución ticket de venta'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfSellTicketRefundTemplates,
                    value: basicData?.PdfSellTicketRefundTemplateId,
                },
                {
                    name: 'PdfSellTicketRefundPDFTemplateId',
                    label: t('pdfSellTicketRefundPDFTemplate', 'Plantilla PDF devolución ticket de ventas'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfSellTicketRefundPDFTemplates,
                    value: basicData?.PdfSellTicketRefundPDFTemplateId,
                },
                {
                    name: 'PdfVoucherTemplateId',
                    label: t('VoucherTemplate', 'Plantilla vale'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfVoucherTemplates,
                    value: basicData?.PdfVoucherTemplateId,
                },
                {
                    name: 'PdfVoucherPDFTemplateId',
                    label: t('pdfVoucherPDFTemplate', 'Plantilla PDF vale'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfVoucherPDFTemplates,
                    value: basicData?.PdfVoucherPDFTemplateId,
                },
                {
                    name: 'PdfGiftTicketTemplateId',
                    label: t('pdfGiftTicketTemplate', 'Plantilla ticket regalo'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfGiftTicketTemplates,
                    value: basicData?.PdfGiftTicketTemplateId,
                },
                {
                    name: 'PdfManufacturingTemplateId',
                    label: t('pdfManufacturingTemplate', 'Plantilla fabricación'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfManufacturingTemplates,
                    value: basicData?.PdfManufacturingTemplateId,
                },
                {
                    name: 'PdfAdjustmentDeliveryNoteTemplateId',
                    label: t('pdfAdjustmentDeliveryNoteTemplate', 'Plantilla albarán de regularización'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: dictPdfAdjustmentDeliveryNoteTemplates,
                    value: basicData?.PdfAdjustmentDeliveryNoteTemplateId,
                },
            ]
        },
    ]
    return (
        <LittleModalCreateEdit className={'flex flex-col'} fields={fields} setOpened={setOpened} url={'/api/app/workingCenter/updateWorkingCenter'} translations={{
            title: t('configWCTemplatesPDF', 'Configurar Plantillas PDF del Centro de trabajo'),
            button: t('save', 'Guardar')
        }} haveButtonPermissions={true} onSubmit={onSubmit} />
    )
}


const modalConfigWCTemplatesPDFDispatch = {
    setPdfTemplates: (payload: PdfQuoteOrderTemplatePayload) => ({ type: 'CHANGE_PDFTEMPLATE', payload }),
}

export type ReduxModalConfigWCTemplatesPDF = ConnectedProps<typeof modalConfigWCTemplatesPDFConnect>
const mapModalConfigWCTemplatesPDFConnector = (state: AllReduxPayloads) => ({ pdfTemplates: state.pdfTemplates })
const modalConfigWCTemplatesPDFConnect = connect(mapModalConfigWCTemplatesPDFConnector, modalConfigWCTemplatesPDFDispatch)

const modalConfigWCTemplatesPDFConnectLoading = withLoading(ModalConfigWCTemplatesPDF, [{ fetchUrl: '/api/app/config/pdfTemplate/getAllPdfTemplates', propName: 'pdfTemplates', setFunctionName: 'setPdfTemplates' }])

const ModalConfigWCTemplatesPDFConnect = modalConfigWCTemplatesPDFConnect(modalConfigWCTemplatesPDFConnectLoading)

export default ModalConfigWCTemplatesPDFConnect